// ===============================
// UserDashboard.tsx
// ===============================
import React from "react";
import { Outlet } from "react-router-dom";

const UserDashboard: React.FC = () => {
  return (
    <div className="w-full">
      <Outlet />
    </div>
  );
};

export default UserDashboard;